export const WATCHLIST_SECTIONS = Object.freeze([
  { key: "Stocks", assetType: "stocks" },
  { key: "Cryptos", assetType: "cryptos" },
  { key: "ForexPairs", assetType: "forex" },
  { key: "Indices", assetType: "indices" },
  { key: "Commodities", assetType: "commodities" },
  { key: "Futures", assetType: "futures" },
]);

export const WATCHLIST_SECTION_KEYS = WATCHLIST_SECTIONS.map(({ key }) => key);

// A row whose quote the account's access withholds: the server sends
// quoteAvailability (for example futures on Free) and null price fields.
// Returns what the price cell shows instead, or null for an ordinary row.
export const withheldWatchlistQuote = (row) => {
  const status = row?.quoteAvailability;
  if (!status) return null;
  if (status === "paid_plan_required") {
    return {
      status,
      label: "Pro",
      title: "Futures quotes are included with Pro and Max",
    };
  }
  return {
    status,
    label: "Unavailable",
    title: "Futures data is temporarily unavailable",
  };
};

const rowName = (row) => String(row?.name || "");

const rowKey = (row) => {
  if (row?.id != null && row.id !== "") return String(row.id);
  return `${row?.assetType || "unknown"}:${row?.ticker || rowName(row)}`;
};

export const groupWatchlistRows = (rows) => {
  const list = Array.isArray(rows) ? rows : [];
  return Object.fromEntries(
    WATCHLIST_SECTIONS.map(({ key, assetType }) => [
      key,
      list
        .filter((row) => row?.assetType === assetType)
        .sort((left, right) => rowName(left).localeCompare(rowName(right))),
    ]),
  );
};

export const mergeGroupedWatchlistRows = (previous, rows) => {
  const byId = new Map();

  WATCHLIST_SECTION_KEYS.forEach((section) => {
    (Array.isArray(previous?.[section]) ? previous[section] : []).forEach((row) => {
      byId.set(rowKey(row), row);
    });
  });

  (Array.isArray(rows) ? rows : []).forEach((row) => {
    const key = rowKey(row);
    byId.set(key, { ...byId.get(key), ...row });
  });

  return groupWatchlistRows(Array.from(byId.values()));
};
